import axios from "axios";

export default {
	async login(payload) {
		return await axios.post("/login", payload);
	},
	async logout() {
		return await axios.post("/logout");
	},
};